import request from '@/utils/request'

//升级单验证
export function verificationSJ(query) {
    return request({
        url: 'order/verificationSJ',
        method: 'get',
        params: query
    })
}

//升级单商品列表
export function goodsListSJByMember(query) {
    return request({
        url: 'order/goodsListSJByMember',
        method: 'get',
        params: query
    })
}

//升级单购买
export function saveSJ(data) {
    return request({
        url: 'order/saveSJ',
        method: 'post',
        data
    })
}

// 孟加拉获取打折后的金额
export function discountedPrice(query) {
    return request({
        url: 'common/discountedPrice',
        method: 'get',
        params: query
    })
}
